import { Entity, Column, PrimaryGeneratedColumn, Check, ManyToOne, JoinColumn } from 'typeorm'
import Response from './Response'

export enum ResponseState {
  UNPROCESSED = 'unprocessed',
  REJECTED_BY_DS = 'rejected_by_ds',
  APPROVED_BY_DS = 'approved_by_ds',
  REJECTED_BY_USER = 'rejected_by_user',
  APPROVED_BY_USER = 'approved_by_user'
}

@Entity('response_events')
@Check(`CASE WHEN (state IN ('rejected_by_ds', 'approved_by_ds')) THEN filter_job_id IS NOT NULL ELSE TRUE END`)
@Check(`CASE WHEN (state IN ('rejected_by_user', 'approved_by_user')) THEN user_id IS NOT NULL ELSE TRUE END`)
export default class ResponseEvent {
  @PrimaryGeneratedColumn('increment')
  id!: number

  @Column({ name: 'created_at' })
  createdAt!: Date

  @Column({
    name: 'state',
    type: 'enum',
    enum: ResponseState
  })
  responseState!: ResponseState

  @Column({ name: 'filter_job_id' })
  filterJobId?: string

  @Column({ name: 'user_id' })
  userId?: string

  @ManyToOne(type => Response, r => r.responseEvents)
  @JoinColumn({ name: 'response_id' })
  response!: Response
}
